import { IPushNotifications } from '../interfaces/IPushNotifications';

export abstract class PushNotifications implements IPushNotifications {
  abstract init(): Promise<void>;
  abstract requestPermissions(): Promise<void>;
}
